import React from 'react';

import JiraFiledValueSelector from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/SelectActions/actions/ActionAdditionalValueSelector/JiraFiledValueSelector';
import Field from 'src/views/components/Form/Field';
import { GenericAsyncSelect } from 'src/views/components/select';

import { useAllActions } from './actions';

const SelectActionsAdditionalParams = ({ selectedActions, ...props }) => {
  const allActions = useAllActions();

  return (
    <div style={{ paddingBottom: '40px', marginTop: '-23px' }}>
      {
        (selectedActions || [])
          .map(action => {
            const { AdditionalParams } = (allActions || []).find(a => a.name === (action && action.key)) || {};
            if (!AdditionalParams) {
              return (
                <Field label={action.label} key={action.key}>
                  <JiraFiledValueSelector
                    isDisabled
                    isMulti={true}
                    value={props?.values && Object.prototype.hasOwnProperty.call(props.values, action.key) ? props.values[action.key] : []}
                  />
                </Field>
              );
            }
            return <AdditionalParams {...props} key={action.key} />;
          })
          .filter(x => Boolean(x))
      }
    </div>
  );
};

const SelectActions = ({ name, values = {}, touched = {}, errors = {}, onChange, onBlur, actions, fixedActions }) => {
  return (
    <div style={{ width: '100%', display: 'flex' }}>
      <div style={{ width: '50%' }}>
        <Field
          errorMessage={touched.actions && errors.actions}
        >
          <GenericAsyncSelect
            fixedOptions={fixedActions}
            key={(actions && actions.length) || 'empty'}
            options={actions}
            name={`${name}.actions`}
            value={values.actions}
            onChange={onChange}
            onBlur={onBlur}
            isMulti
            hasIcons
          />
        </Field>
      </div>
      <div style={{ width: '10px' }} />
      <div style={{ width: '50%' }}>
        <SelectActionsAdditionalParams
          name={`${name}.actions_params`}
          values={values.actions_params}
          targetService={values.target_service}
          touched={touched.actions_params}
          errors={errors.actions_params}
          onChange={onChange}
          onBlur={onBlur}
          selectedActions={values.actions}
        />
      </div>
    </div>
  );
};

export default SelectActions;
